module.exports = __webpack_public_path__ + "media/images/p-about/partner/西条市-b475b1b3621fb2daa74f0eed541437f6.png";